<template>
  <section class="row mt-3 section-contact">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <div class="row">
            <h1 class="section-title">Liên hệ</h1>
          </div>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-12 text-center">
          <address>
            <p><strong>Địa chỉ:</strong> 22 Hồng Hà P.2 Q.Tân Bình HCM</p>
            <p><strong>Email:</strong> info@thienthuonghoa.vn</p>
          </address>
        </div>
        <div class="col-12">
          <iframe
            allowfullscreen=""
            frameborder="0"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3918.975809579846!2d106.66520285100258!3d10.813162992258805!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x317529187ded6cbb%3A0xc6eff6ce96240777!2zMjIgSOG7k25nIEjDoCwgUGjGsOG7nW5nIDIsIFTDom4gQsOsbmgsIEjhu5MgQ2jDrSBNaW5oLCBWaeG7h3QgTmFt!5e0!3m2!1svi!2sus!4v1592123431660!5m2!1svi!2sus"
            style="border:0;"
            width="100%"
            height="500px"
          ></iframe>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
export default {
  name: "ContactPageComponent",
};
</script>

<style scoped></style>
